module.exports = __webpack_public_path__ + "static/media/image-cel.f7d139aa.svg";